import { catalog } from "../i18n.js";

/**
 * What a bot is doing, in a few words (state.ts describeActivity). Each is a
 * phrase that reads both on its own, capitalised ("Running a command…"), and
 * after the bot's name ("Nara is running a command…"; Indonesian "Nara
 * sedang menjalankan perintah…").
 */
export const ACTIVITY = catalog(
  {
    typing: "typing",
    reacting: "reacting",
    startingTask: "starting the task",
    stoppingTask: "stopping the task",
    writingToBot: "writing to another bot",
    checkingProgress: "checking progress",
    updatingTask: "updating the task",
    runningCommand: "running a command",
    lookingThroughFiles: "looking through files",
    editingFiles: "editing files",
    searchingWeb: "searching the web",
    readingPage: "reading a page",
    readingHost: (host: string) => `reading ${host}`,
    browsing: "browsing",
    browsingHost: (host: string) => `browsing ${host}`,
    usingDesktop: "using the desktop",
    usingTool: (name: string) => `using ${name}`,
    error: (message: string) => `Error: ${message}`,
  },
  {
    typing: "mengetik",
    reacting: "memberi reaksi",
    startingTask: "memulai tugas",
    stoppingTask: "menghentikan tugas",
    writingToBot: "menulis ke bot lain",
    checkingProgress: "memeriksa perkembangan",
    updatingTask: "memperbarui tugas",
    runningCommand: "menjalankan perintah",
    lookingThroughFiles: "melihat-lihat file",
    editingFiles: "mengubah file",
    searchingWeb: "mencari di web",
    readingPage: "membaca halaman",
    readingHost: (host: string) => `membaca ${host}`,
    browsing: "menjelajah web",
    browsingHost: (host: string) => `menjelajah ${host}`,
    usingDesktop: "memakai komputer",
    usingTool: (name: string) => `memakai ${name}`,
    error: (message: string) => `Kesalahan: ${message}`,
  },
);
